module.exports = __webpack_public_path__ + "media/how_fastweb_works/usnews_logo_03-a1f6734b.png";